var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42136_138377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4029 5.23438L15.2827 5.2431C15.0457 5.27772 14.8318 5.41364 14.6969 5.6203L12.6844 8.70104H8.61502C6.8968 8.70104 5.50391 10.1238 5.50391 11.8788V24.5899C5.50391 26.345 6.8968 27.7677 8.61502 27.7677H28.9787C30.6969 27.7677 32.0898 26.345 32.0898 24.5899V11.8788L32.0841 11.6852C31.9861 10.0203 30.6332 8.70104 28.9787 8.70104H24.9082L22.8968 5.6203C22.7394 5.3792 22.4745 5.23438 22.1908 5.23438H15.4029ZM15.8566 6.96771H21.736L23.7474 10.0484C23.9048 10.2896 24.1697 10.4344 24.4534 10.4344H28.9787C29.7597 10.4344 30.3928 11.0811 30.3928 11.8788V24.5899C30.3928 25.3877 29.7597 26.0344 28.9787 26.0344H8.61502C7.83401 26.0344 7.20088 25.3877 7.20088 24.5899V11.8788C7.20088 11.0811 7.83401 10.4344 8.61502 10.4344H13.1403L13.2604 10.4257C13.4975 10.391 13.7114 10.2551 13.8463 10.0484L15.8566 6.96771Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7956 12.1641C15.8278 12.1641 13.4219 14.6215 13.4219 17.653C13.4219 20.6844 15.8278 23.1418 18.7956 23.1418C21.7634 23.1418 24.1694 20.6844 24.1694 17.653C24.1694 14.6215 21.7634 12.1641 18.7956 12.1641ZM18.7956 13.8974C20.8262 13.8974 22.4724 15.5788 22.4724 17.653C22.4724 19.7271 20.8262 21.4085 18.7956 21.4085C16.765 21.4085 15.1188 19.7271 15.1188 17.653C15.1188 15.5788 16.765 13.8974 18.7956 13.8974Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42136_138377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white",
    transform: "translate(4.79688 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSmall);
export default __webpack_public_path__ + "static/media/camera-small.91279f3eba7781285ad11a030b2accd4.svg";
export { ForwardRef as ReactComponent };